module.exports = [
	{
		item: {
			title: "Testimonials",
			feature_image: "/images/testimonials/maya-hennerkes.jpeg",
			html: "<em>“The current COVID crisis puts the spotlight on the relevance of this collaboration between Think Plus, EBRD, HRADF and Global Sustain. The ESG tool will allow HRADF and other financial institutions going forward to address three important trends for a post-COVID world: ESG Integration will build resilience and sustainability into the investment process. Digitalisation will enable agile, efficient and remotely accessible environmental and social data management.”</em><br><br>Let me also take advantage to thank you for your tireless work on this beautiful project. I look very much forward to continue working with you and scaling this up now so that our banking and private equity clients can benefit at large from the tool.",
			person: "Maya Hennerkes<br> Sector Lead Financial Intermediaries<br> Environment and Sustainability Department<br> European Bank for Reconstruction and Development"
		}
	},
	{
		item: {
			title: "Testimonials",
			feature_image: "/images/testimonials/spanos-michael-ceo-global-sustain.jpg",
			html: "«Excellent job, in every field. Think Plus is the best partner in the digital era.»",
			person: "Spanos Michael<br> CEO Global Sustain"
		}
	},
	{
		item: {
			title: "Testimonials",
			feature_image: "/images/testimonials/harry-kalyvas-ceo-clip-talk.jpg",
			html: "«Top level work, nothing like a typical agency..! They should move to the States!!»",
			person: "Kalyvas Charalampos<br> CEO Clip&Talk"
		}
	},
	{
		item: {
			title: "Testimonials",
			feature_image: "/images/icons/avatar-female.jpg",
			html: "«Think Plus is a great partner to work with, both in video production and demanding web services. They always deliver on time with the best quality possible.»",
			person: "Dimopoulou Ioanna<br> Marketing Director Incadea GmbH"
		}
	},
	{
		item: {
			title: "Testimonials",
			feature_image: "/images/testimonials/kokosioulis-dynamic-vision.jpg",
			html: "Dear Think Plus team, On behalf of the Dynamic Vision team we would like to thank you for a video delivered on time and of very high standards. Your job has already made an impact on the Interreg MED Programme and is expected to do make our Green Growth Community more visible to relevant stakeholders in the following transnational events that are going to take place the next years. Waiting for future collaborations",
			person: "Dr. Dimitrios Kokosioulis<br> Dynamic Vision"
		}
	}
]

// {
// 	item: {
// 		title: "Testimonials",
// 		feature_image: "/images/testimonials/",
// 		html: "",
//		person: ""
// 	}
// }
